if (!customElements.get('hero-video')) {
  class HeroVideo extends HTMLElement {
    constructor() {
      super();
      this.videoPlaying = false;
      this.playButton = document.querySelector('[data-video-play-button]');
      this.videoWrapper = this.querySelector('[data-video-wrapper]');
      this.video = this.videoWrapper.querySelector('video');

      if (this.playButton) {
        this.playButton.addEventListener('click', this.toggleVideo.bind(this));
      }

      if (this.video) {
        this.setVideoSource();
        this.video.load();

        this.video.addEventListener('loadeddata', () => {
          const pauseIcon = this.playButton.querySelector('.pause-icon');
          const playIcon = this.playButton.querySelector('.play-icon');

          this.playVideo();
          this.videoPlaying = true;
          pauseIcon.classList.remove('d-none');
          playIcon.classList.add('d-none');
        });
      }
    }

    setVideoSource() {
      if (this.video) {
        const source = this.video.firstChild;

        if (window.innerWidth < 768) {
          source.setAttribute('src', source.getAttribute('data-mobile-src'));
        } else {
          source.setAttribute('src', source.getAttribute('data-desktop-src'));
        }
      }
    }

    playVideo() {
      const placeholder = this.querySelector('[data-video-placeholder-image]');

      if (this.video) {
        this.video.play();
      }

      placeholder.classList.add('d-none');
      this.videoWrapper.classList.remove('d-none');
    }

    pauseVideo() {
      this.playButton.querySelector('.pause-icon').classList.add('d-none');
      this.playButton.querySelector('.play-icon').classList.remove('d-none');

      if (this.video) {
        this.video.pause();
      }
    }

    toggleVideo() {
      const pauseIcon = this.playButton.querySelector('.pause-icon');
      const playIcon = this.playButton.querySelector('.play-icon');

      if (this.videoPlaying) {
        this.pauseVideo();
        this.videoPlaying = false;
        pauseIcon.classList.add('d-none');
        playIcon.classList.remove('d-none');
      } else {
        this.playVideo();
        this.videoPlaying = true;
        pauseIcon.classList.remove('d-none');
        playIcon.classList.add('d-none');
      }
    }
  }

  customElements.define('hero-video', HeroVideo);
}
